export const CartPagePublish = () => {
    return (
        <>
            <div className="content_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">내 장바구니</h3>
                    <div className="filter_toolbar"><button class="btn btn-primary w-120px">모두 구매하기</button></div>
                </div>

                <div className="table_scroll">
                    <table className="table table-bordered my_table">
                        <colgroup>
                            <col style={{ width: "302px" }} />
                            <col />
                            <col style={{ width: "130px" }} />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>이미지</th>
                                <th>상품정보</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {[0, 1, 2, 3, 4].map(() => (<tr className="h-166px">
                                <td className="p-4px"><img src={process.env.PUBLIC_URL + "/assets/images/img_cart_thumb.png"} alt="" width={"100%"} /></td>
                                <td>
                                    <div className="line0 mb-5px">[Microsoft] Compact</div>
                                    <div className="line1 mb-3px">S1-WIN Emb Compact 7 C7E</div>
                                    <div className="line2 mb-16px">TNA-00022</div>
                                    <div className="line3_lg">설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸 설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸..</div>
                                </td>
                                <td>
                                    <div className="d-flex flex-column justify-content-center align-items-center">
                                        <button className="btn btn-outline-dark w-110px mx-0 mb-5px px-0"><img className="me-5px" src={process.env.PUBLIC_URL + "/assets/images/icon_cross.png"} alt="" />제품삭제</button>
                                        <div className="input-group input_magic_control mx-0 mb-5px">
                                            <span className="input-group-text">
                                                <img src={process.env.PUBLIC_URL + "/assets/images/icon_minus_btn.png"} alt="" />
                                            </span>
                                            <input type="text" className="form-control" aria-label="Amount (to the nearest dollar)" value={1} />
                                            <span className="input-group-text">
                                                <img src={process.env.PUBLIC_URL + "/assets/images/icon_plus_btn.png"} alt="" />
                                            </span>
                                        </div>
                                        <button className="btn btn-dark  mx-0 w-110px">구매하기</button>
                                    </div>
                                </td>
                            </tr>))}
                        </tbody>
                    </table>
                </div>

                <div className="pagination-container">
                    <ul>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_first.png"}
                                alt="First Page"
                                className=""
                            />
                        </li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_prev.png"}
                                alt="Previous Page"
                                className=""
                            />
                        </li>
                        <li className="active">1</li>
                        <li className="">2</li>
                        <li className="">3</li>
                        <li className="">4</li>
                        <li className="">5</li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_next.png"}
                                alt="Next Page"
                                className=""
                            />
                        </li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_last.png"}
                                alt="Last Page"
                                className=""
                            />
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
}